<template>
  <Card tag="form" class="page-mutate-devtools" @submit.prevent="$emit('submit')" :title="$t('devtools')">
    <template #default>
      <InputComponent label="Custom CSS">
        <PrismEditor v-model="value.inject.css" language="css" line-numbers />
      </InputComponent>
      <InputComponent label="Custom JS" class="mt-2">
        <PrismEditor v-model="value.inject.js" language="js" line-numbers />
      </InputComponent>
      <CustomFields
        v-model="value.customFields"
        :schema="customFieldSchemas"
        :data="data"
        :placement="['devtools', 'page:devtools']"
        :validator="validator"
        validator-prefix="customFields"
        :disabledFields="$path('metadata.disabledFields.page', item)"
      />
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'
import Store from '@/store'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import PrismEditor from '@/components/PrismEditor'
import CustomFields from '@kvass/custom-fields'

const meta = {
  order: 1004,
  skip: !Store.getters.isDeveloper,
  id: 'devtools',
  label: i18n.t('devtools'),
  icon: ['fal', 'code'],
}

export { meta }
export default {
  props: {
    value: Object,
    data: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
  },
  computed: {
    ...mapState('Page', {
      item(state) {
        return state.item && Object.keys(state.item).length ? state.item : this.data
      },
    }),
    ...mapState(['enums']),
  },
  components: {
    Card,
    InputComponent,
    CustomFields,
    PrismEditor,
  },
}
</script>

<style lang="scss">
.page-mutate-devtools {
  max-width: 1000px;
}
</style>
